'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _document = require('redux/modules/document');

var _schoollevels = require('redux/modules/schoollevels');

var _chapter = require('redux/modules/chapter');

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _components = require('../../components');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _reactRouter = require('react-router');

var _Parser = require('../../helpers/Parser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Document = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(options) {
    var dispatch = options.store.dispatch,
        _options$params = options.params,
        documentId = _options$params.documentId,
        chapterId = _options$params.chapterId;


    return _promise2.default.all([dispatch((0, _document.load)(documentId)), dispatch((0, _chapter.load)(chapterId)), dispatch((0, _schoollevels.load)())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    chapter: state.chapter.data,
    document: state.document.data,
    saving: state.document.saving,
    uploadingImage: state.document.uploadingImage,
    uploadedImage: state.document.image,
    config: state.config
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Document, _Component);

  function Document(props) {
    (0, _classCallCheck3.default)(this, Document);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Document.__proto__ || (0, _getPrototypeOf2.default)(Document)).call(this, props));

    _initialiseProps.call(_this);

    _this.handleExerciseSelection = function (index) {
      return _this._handleExerciseSelection(index);
    };
    _this.handleCreateExercise = function () {
      return _this._handleCreateExercise();
    };
    _this.handleCreateQuestion = function () {
      return _this._handleCreateQuestion();
    };
    _this.onListChange = function (newList, movedItem, oldIndex, newIndex) {
      return _this._onListChange(newList, movedItem, oldIndex, newIndex);
    };
    _this.createReferences = function (document) {
      return _this._createReferences(document);
    };

    var document = props.document;

    document.exercises.forEach(function (exercise, exerciseIndex) {
      exercise.questions.forEach(function (question, questionIndex) {
        document.exercises[exerciseIndex].questions[questionIndex].id = questionIndex;
      });
    });

    _this.state = {
      selectedExerciseIndex: 0,
      document: document,
      references: _this.createReferences(document),
      saving: props.saving,
      uploadingImage: false,
      uploadedImage: undefined,
      imageUploadModalVisible: false,
      sectionObject: null,
      sectionProperty: null,
      sectionIndex: null
    };
    return _this;
  }

  (0, _createClass3.default)(Document, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.document !== 'undefined') {
        var document = nextProps.document;

        document.exercises.forEach(function (exercise, exerciseIndex) {
          exercise.questions.forEach(function (question, questionIndex) {
            document.exercises[exerciseIndex].questions[questionIndex].id = questionIndex;
          });
        });
        this.setState({
          document: document,
          references: this.createReferences(document, 0),
          saving: nextProps.saving
        });
      }

      if (typeof nextProps.uploadingImage !== 'undefined') {
        this.setState({
          uploadingImage: nextProps.uploadingImage
        });
      }

      if (typeof nextProps.uploadedImage !== 'undefined') {
        navigator.clipboard.writeText('[image:' + nextProps.uploadedImage.filename + ']');
        this.setState({
          uploadedImage: nextProps.uploadedImage
        });
      }
    }
  }, {
    key: '_onListChange',
    value: function _onListChange(newList, movedItem, oldIndex, newIndex) {
      var document = this.state.document;

      var exercise = document.exercises[oldIndex];

      document.exercises.splice(oldIndex, 1);
      document.exercises.splice(newIndex, 0, exercise);

      for (var pos = 0; pos < newList.length; pos++) {
        newList[pos].index = pos;
      }

      this.setState({
        document: document,
        references: newList,
        selectedExerciseIndex: newIndex
      });
    }
  }, {
    key: '_handleExerciseSelection',
    value: function _handleExerciseSelection(index) {
      this.setState({
        selectedExerciseIndex: index,
        sectionObject: undefined,
        sectionProperty: undefined,
        sectionIndex: undefined
      });
    }
  }, {
    key: '_handleCreateExercise',
    value: function _handleCreateExercise() {
      var document = this.state.document;


      document.exercises.push({
        header: '',
        questions: [{
          header: '',
          question: '',
          answer: ''
        }]
      });

      this.setState({
        document: document,
        selectedExerciseIndex: document.exercises.length - 1,
        references: this.createReferences(document, 0),
        questionsSortMode: false
      });
    }
  }, {
    key: '_handleCreateQuestion',
    value: function _handleCreateQuestion() {
      var _state = this.state,
          document = _state.document,
          selectedExerciseIndex = _state.selectedExerciseIndex;


      document.exercises[selectedExerciseIndex].questions.push({
        header: '',
        question: '',
        answer: ''
      });

      this.setState({
        document: document,
        references: this.createReferences(document, selectedExerciseIndex)
      });
    }
  }, {
    key: '_createReferences',
    value: function _createReferences(document, selectedExerciseIndex) {
      var _this2 = this;

      var selectedIndex = 0;

      if (typeof selectedExerciseIndex !== 'undefined') {
        selectedIndex = selectedExerciseIndex;
      }

      if (typeof document !== 'undefined') {
        return document.exercises.map(function (exercise, index) {
          var id = exercise.id || index;

          return {
            index: index,
            id: id,
            questionsCount: exercise.questions.length,
            difficultyLevel: exercise.difficultyLevel || '-',
            duration: exercise.duration || 0,
            isEssential: exercise.isEssential,
            onClick: _this2.handleExerciseSelection,
            selected: index === selectedIndex
          };
        });
      }

      return [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Document.scss');
      var _state2 = this.state,
          selectedExerciseIndex = _state2.selectedExerciseIndex,
          document = _state2.document,
          references = _state2.references,
          questionsSortMode = _state2.questionsSortMode,
          saving = _state2.saving,
          uploadingImage = _state2.uploadingImage,
          imageUploadModalVisible = _state2.imageUploadModalVisible,
          uploadedImage = _state2.uploadedImage;
      var _props = this.props,
          schoolLevels = _props.schoolLevels,
          chapter = _props.chapter,
          routeParams = _props.routeParams,
          config = _props.config;

      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === routeParams.schoolLevelId;
      });
      var exercise = document.exercises[selectedExerciseIndex];
      var innerHTML = function innerHTML(html) {
        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _Parser.textToHtml)(document._id, html, config) } });
      };

      exercise.questions.forEach(function (question, index) {
        exercise.questions[index].rank = index + 1;
      });

      return _react2.default.createElement(
        'div',
        { className: styles.document },
        _react2.default.createElement('input', { type: 'file', className: styles.imageUploadInput, ref: function ref(input) {
            return _this3.uploadImageInput = input;
          }, onChange: this.handleImageUploadChange }),
        imageUploadModalVisible && _react2.default.createElement(
          _components.Modal,
          { saving: uploadingImage, className: styles.imageUploadModal, onClose: this.handleCloseImageUploadModal },
          uploadedImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              'Code de l\'image \xE0 copier'
            ),
            _react2.default.createElement('textarea', { disabled: true, value: '[image:' + uploadedImage.filename + ']' })
          ),
          uploadingImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Import de l\'image en cours...'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.newDocumentToolbar },
          _react2.default.createElement(
            'span',
            { className: styles.breadcrumb },
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id },
              schoolLevel.name
            ),
            '\xA0\xA0>\xA0\xA0',
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id },
              chapter.title
            ),
            '\xA0\xA0>\xA0\xA0',
            document.title
          ),
          _react2.default.createElement(
            'button',
            { className: styles.documentSaveButton, onClick: this.handleOpenImageUploadModal },
            'Importer une image'
          ),
          _react2.default.createElement(
            'button',
            { className: styles.documentSaveButton, onClick: this.handleSwitchQuestionsSortMode },
            questionsSortMode ? 'Mode édition' : 'Mode tri'
          ),
          _react2.default.createElement(
            _reactLadda2.default,
            { className: styles.documentSaveButton,
              'data-style': 'slide-down',
              loading: saving, onClick: this.handleSaveDocument },
            _react2.default.createElement(
              'span',
              null,
              'Enregistrer'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesList },
          _react2.default.createElement(_reactDraggableList2.default, {
            commonProps: { selectedExerciseIndex: selectedExerciseIndex },
            itemKey: 'id',
            template: _components.ExercisesListItem,
            list: references,
            onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
              return _this3.onListChange(newList, movedItem, oldIndex, newIndex);
            },
            container: function container() {
              return document.body;
            }
          }),
          _react2.default.createElement(
            'div',
            { onClick: this.handleCreateExercise,
              className: styles.exercisesListAddItem },
            _react2.default.createElement(
              'div',
              { className: styles.exercisesListItemTitle },
              '+'
            )
          )
        ),
        !questionsSortMode ? _react2.default.createElement(
          'div',
          { className: styles.contentTextArea },
          _react2.default.createElement('textarea', { value: this.sectionValue(),
            onChange: this.handleTextareaChange,
            placeholder: 'Vide' })
        ) : null,
        _react2.default.createElement(
          'div',
          { className: styles.content },
          exercise ? _react2.default.createElement(
            'div',
            null,
            selectedExerciseIndex > 0 ? _react2.default.createElement(
              'div',
              { onClick: this.handleDeleteExercise, className: styles.exerciseDeleteButton },
              _react2.default.createElement('i', { className: styles.deleteQuestionButton + ' fa fa-trash-o',
                'aria-hidden': 'true' }),
              'Supprimer l\'exercise'
            ) : null,
            _react2.default.createElement(
              'div',
              { className: styles.difficultyInfos },
              _react2.default.createElement(
                'b',
                null,
                'Difficult\xE9 / Dur\xE9e de l\'exercice'
              ),
              _react2.default.createElement(
                'p',
                null,
                '\uD83D\uDCAA ',
                _react2.default.createElement('input', { type: 'number', min: 1, max: 3, onChange: this.handleDifficultyLevelChange, value: exercise.difficultyLevel }),
                ' / 3'
              ),
              _react2.default.createElement(
                'p',
                null,
                '\u23F1\uFE0F ',
                _react2.default.createElement('input', { type: 'number', min: 1, max: 99, onChange: this.handleDurationChange, value: exercise.duration / 60 }),
                ' min'
              ),
              _react2.default.createElement(
                'p',
                null,
                '\u2B50 ',
                _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleIsEssentialChange, checked: exercise.isEssential })
              )
            ),
            !questionsSortMode ? _react2.default.createElement(
              'div',
              { className: styles.exercise },
              _react2.default.createElement(
                'div',
                { className: styles.exerciseHeader + (this.isSelectedSection('header', -1) ? ' selected' : ''),
                  onClick: this.handleSectionClick.bind(null, exercise, 'header', -1) },
                innerHTML(exercise.header)
              ),
              exercise.questions.map(function (question, index) {
                return _react2.default.createElement(
                  'div',
                  { key: 'question-' + index, className: styles.question },
                  _react2.default.createElement('i', { className: styles.deleteQuestionButton + ' fa fa-trash-o',
                    'aria-hidden': 'true',
                    onClick: _this3.deleteQuestion.bind(null, index) }),
                  _react2.default.createElement(
                    'div',
                    { className: styles.questionHeader + (_this3.isSelectedSection('header', index) ? ' selected' : ''),
                      onClick: _this3.handleSectionClick.bind(null, question, 'header', index) },
                    innerHTML(question.header)
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.questionTitle + (_this3.isSelectedSection('question', index) ? ' selected' : ''),
                      onClick: _this3.handleSectionClick.bind(null, question, 'question', index) },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'i',
                        { className: styles.questionNumber },
                        index + 1
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      innerHTML(question.question)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.questionAnswer + (_this3.isSelectedSection('answer', index) ? ' selected' : ''),
                      onClick: _this3.handleSectionClick.bind(null, question, 'answer', index) },
                    innerHTML(question.answer)
                  )
                );
              }),
              _react2.default.createElement(
                'div',
                { onClick: this.handleCreateQuestion, className: styles.questionAddButton },
                _react2.default.createElement(
                  'i',
                  null,
                  'Ajouter une question'
                )
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reactDraggableList2.default, {
                itemKey: 'id',
                list: exercise.questions,
                template: _components.QuestionsListItem,
                onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
                  return _this3.onQuestionsListChange(newList, movedItem, oldIndex, newIndex);
                },
                container: function container() {
                  return document.body;
                }
              })
            )
          ) : null
        )
      );
    }
  }]);
  return Document;
}(_react.Component), _class2.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  chapter: _react.PropTypes.object.isRequired,
  document: _react.PropTypes.object.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  config: _react.PropTypes.object.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onQuestionsListChange = function (newList, movedItem, oldIndex, newIndex) {
    var _state3 = _this4.state,
        document = _state3.document,
        selectedExerciseIndex = _state3.selectedExerciseIndex;

    var question = document.exercises[selectedExerciseIndex].questions[oldIndex];

    document.exercises[selectedExerciseIndex].questions.splice(oldIndex, 1);
    document.exercises[selectedExerciseIndex].questions.splice(newIndex, 0, question);

    _this4.setState({
      document: document
    });
  };

  this.togglePublish = function () {
    var document = _this4.state.document;

    document.published = !document.published;
    _this4.setState({
      document: document
    });
  };

  this.handleSectionClick = function (sectionObject, sectionProperty, sectionIndex) {
    _this4.setState({
      sectionObject: sectionObject,
      sectionProperty: sectionProperty,
      sectionIndex: sectionIndex
    });
  };

  this.isSelectedSection = function (property, index) {
    var _state4 = _this4.state,
        sectionProperty = _state4.sectionProperty,
        sectionIndex = _state4.sectionIndex;

    return sectionProperty === property && sectionIndex === index;
  };

  this.sectionValue = function () {
    if (_this4.state.sectionObject && _this4.state.sectionProperty) {
      return _this4.state.sectionObject[_this4.state.sectionProperty].replace(/<br\s*\/?>/mg, '\n');
    }

    return '';
  };

  this.handleTextareaChange = function (event) {
    var sectionObject = _this4.state.sectionObject;
    sectionObject[_this4.state.sectionProperty] = event.target.value.replace(/\r?\n/g, '<br />');
    _this4.setState({ sectionObject: sectionObject });
  };

  this.handleSwitchQuestionsSortMode = function () {
    var questionsSortMode = _this4.state.questionsSortMode;

    _this4.setState({
      questionsSortMode: !questionsSortMode
    });
  };

  this.handleSaveDocument = function () {
    _this4.props.dispatch((0, _document.save)(_this4.state.document));
  };

  this.deleteQuestion = function (index) {
    var _state5 = _this4.state,
        document = _state5.document,
        selectedExerciseIndex = _state5.selectedExerciseIndex;


    document.exercises[selectedExerciseIndex].questions.splice(index, 1);

    _this4.setState({
      document: document
    });
  };

  this.handleDeleteExercise = function () {
    var _state6 = _this4.state,
        document = _state6.document,
        selectedExerciseIndex = _state6.selectedExerciseIndex;


    if (selectedExerciseIndex > 0) {
      document.exercises.splice(selectedExerciseIndex, 1);
      _this4.setState({
        selectedExerciseIndex: selectedExerciseIndex - 1,
        document: document,
        references: _this4.createReferences(document, 0)
      });
    }
  };

  this.handleOpenImageUploadModal = function () {
    _this4.uploadImageInput.click();
  };

  this.handleCloseImageUploadModal = function () {
    _this4.setState({
      imageUploadModalVisible: false,
      uploadedImage: undefined
    });
  };

  this.handleDifficultyLevelChange = function (event) {
    var _state7 = _this4.state,
        document = _state7.document,
        selectedExerciseIndex = _state7.selectedExerciseIndex;

    document.exercises[selectedExerciseIndex].difficultyLevel = parseInt(event.target.value, 10);

    _this4.setState({
      document: document,
      references: _this4.createReferences(document, selectedExerciseIndex)
    });
  };

  this.handleDurationChange = function (event) {
    var _state8 = _this4.state,
        document = _state8.document,
        selectedExerciseIndex = _state8.selectedExerciseIndex;

    document.exercises[selectedExerciseIndex].duration = parseInt(event.target.value, 10) * 60;

    _this4.setState({
      document: document,
      references: _this4.createReferences(document, selectedExerciseIndex)
    });
  };

  this.handleIsEssentialChange = function (event) {
    var _state9 = _this4.state,
        document = _state9.document,
        selectedExerciseIndex = _state9.selectedExerciseIndex;

    console.log(event.target.checked);
    document.exercises[selectedExerciseIndex].isEssential = event.target.checked;
    console.log(document.exercises[selectedExerciseIndex].isEssential);

    _this4.setState({
      document: document,
      references: _this4.createReferences(document, selectedExerciseIndex)
    });
  };

  this.handleImageUploadChange = function (event) {
    var data = new FormData();
    data.append('file', event.target.files[0]);
    _this4.setState({
      imageUploadModalVisible: true
    });
    _this4.props.dispatch((0, _document.uploadImage)({ documentId: _this4.state.document._id, data: data }));
  };
}, _temp)) || _class) || _class);
exports.default = Document;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Document/Document.js
// module id = 1186
// module chunks = 0